import { CLASSIFICACAO_BACKOFFICE } from '@modules/solicitacoes/constants/classificacao'

// === Comunicação (chat) ===
export const conversas = (state) => state.conversas || []
export const selectedConversa = (state) => state.selectedConversa
export const mensagens = (state) => state.mensagens || []
export const loadingConversas = (state) => state.loadingConversas
export const loadingMensagens = (state) => state.loadingMensagens
export const uploadProgress = (state) => state.uploadProgress
export const replyTo = (state) => state.replyTo
// Modo do chat (`generator` × `responder`). Getter dedicado para os
// consumidores lerem por `$store.getters`, e nunca `state.solicitacoes.mode`
// cru — o módulo acessa store por getters/dispatch.
export const mode = (state) => state.mode || null
export const noteMode = (state) => state.noteMode
export const editingMessage = (state) => state.editingMessage
export const respostasRapidas = (state) => state.respostasRapidas || []
export const filtroStatus = (state) => state.filtroStatus
export const filtroProfissional = (state) => state.filtroProfissional

// === Solicitações REAIS (backend aawz_solicitacoes) ===
// Getters do módulo Solicitações — 100% REAL (backend aawz_solicitacoes).
export const solicitacoes = (state) => {
  return state.solicitacoes.data || []
}
export const solicitacoesLoading = (state) => {
  return state.solicitacoes.loading || false
}
export const solicitacoesLastUpdate = (state) => {
  return state.solicitacoes.lastUpdate || null
}

export const areas = (state) => {
  return state.areas.data || []
}
export const areasLoading = (state) => {
  return state.areas.loading || false
}
export const areasLastUpdate = (state) => {
  return state.areas.lastUpdate || null
}

export const tipos = (state) => {
  return state.tipos.data || []
}
export const tiposLoading = (state) => {
  return state.tipos.loading || false
}
export const tiposLastUpdate = (state) => {
  return state.tipos.lastUpdate || null
}

// === Getters por esteira (US-5 — WS fila backoffice) ===
// Aditivos: tipos/areas (acima) continuam servindo Comunicação, Calendário, Jornada,
// Catálogo, Settings e WS sem nenhuma mudança de shape/retorno.
//
// PARIDADE: onde a classificação não vai (undefined) ou vem desconhecida, cai no slot
// ESTRATÉGICO — o mesmo array que `tipos`/`areas` sempre devolveram. Só 'backoffice'
// explícito lê o slot novo `state.catalogoBackoffice` (criado em paralelo por T002).
//
// DEFENSIVO: `state.catalogoBackoffice` pode não existir ainda (T002 em paralelo) —
// nesse caso o slot backoffice devolve [] / false, nunca undefined/erro.
const catalogoBackofficeSlot = (state, chave) => {
  const bloco = state.catalogoBackoffice || {}
  return bloco[chave] || {}
}

export const tiposPorEsteira = (state) => (classificacao) => {
  if (classificacao === CLASSIFICACAO_BACKOFFICE) {
    return catalogoBackofficeSlot(state, 'tipos').data || []
  }
  return tipos(state)
}

export const areasPorEsteira = (state) => (classificacao) => {
  if (classificacao === CLASSIFICACAO_BACKOFFICE) {
    return catalogoBackofficeSlot(state, 'areas').data || []
  }
  return areas(state)
}

export const catalogoBackofficeLoading = (state) => {
  const tiposLoadingBackoffice = catalogoBackofficeSlot(state, 'tipos').loading || false
  const areasLoadingBackoffice = catalogoBackofficeSlot(state, 'areas').loading || false
  return tiposLoadingBackoffice || areasLoadingBackoffice
}

export const tarefas = (state) => {
  return state.tarefas.data || []
}
export const tarefasLoading = (state) => {
  return state.tarefas.loading || false
}
export const tarefasLastUpdate = (state) => {
  return state.tarefas.lastUpdate || null
}

export const arquivos = (state) => {
  return state.arquivos.data || []
}
export const arquivosLoading = (state) => {
  return state.arquivos.loading || false
}
export const arquivosLastUpdate = (state) => {
  return state.arquivos.lastUpdate || null
}

// === Configurações (Settings > Solicitações — visão INTERNA AAWZ) ===
// Getters sempre com default ([] / false), nunca undefined — defensivos contra
// `state.configuracoes` ausente (montagens isoladas em teste).
const configBloco = (state, chave) => {
  const cfg = state.configuracoes || {}
  return cfg[chave] || {}
}

export const configTipos = (state) => {
  return configBloco(state, 'tipos').data || []
}
export const configTiposLoading = (state) => {
  return configBloco(state, 'tipos').loading || false
}
export const configTiposLastUpdate = (state) => {
  return configBloco(state, 'tipos').lastUpdate || null
}

export const configVinculos = (state) => {
  return configBloco(state, 'vinculos').data || []
}
export const configVinculosLoading = (state) => {
  return configBloco(state, 'vinculos').loading || false
}
export const configVinculosLastUpdate = (state) => {
  return configBloco(state, 'vinculos').lastUpdate || null
}

export const configConexoes = (state) => {
  return configBloco(state, 'conexoes').data || []
}
export const configConexoesLoading = (state) => {
  return configBloco(state, 'conexoes').loading || false
}
export const configConexoesLastUpdate = (state) => {
  return configBloco(state, 'conexoes').lastUpdate || null
}

export const configVinculosEstagio = (state) => {
  return configBloco(state, 'vinculosEstagio').data || []
}
export const configVinculosEstagioLoading = (state) => {
  return configBloco(state, 'vinculosEstagio').loading || false
}
export const configVinculosEstagioLastUpdate = (state) => {
  return configBloco(state, 'vinculosEstagio').lastUpdate || null
}

// Sessão/contexto ativo.
export const sessao = (state) => {
  return state.sessao
}

// Pergunta ancorada aguardando o Consultor (spec-008). Default '' — a casca a repassa como
// prop String para o motor de chat, que não pode receber undefined.
export const perguntaPendenteConsultor = (state) => {
  return state.perguntaPendenteConsultor || ''
}

// Painel lateral do Consultor no Hub. Default `false` — o layout lê isto para
// decidir o squeeze e não pode receber undefined.
export const consultorPainelAberto = (state) => {
  return !!state.consultorPainelAberto
}

export const loading = (state) => {
  return !!state.loading
}

export const loaded = (state) => {
  return !!state.loaded
}

// --- OPERACAO_AAWZ (AAWZ profissional, cross-office). Lista crua /interno + detalhe (mesmo padrão
// dos reais: o "carregado" deriva do lastUpdate).
export const operacaoAawzSolicitacoes = (state) => {
  return (state.operacaoAawzSolicitacoes && state.operacaoAawzSolicitacoes.data) || []
}

export const operacaoAawzSolicitacoesLoading = (state) => {
  return (state.operacaoAawzSolicitacoes && state.operacaoAawzSolicitacoes.loading) || false
}

export const operacaoAawzSolicitacoesCarregado = (state) => {
  return !!(state.operacaoAawzSolicitacoes && state.operacaoAawzSolicitacoes.lastUpdate)
}

// Cache de árvores pm_task por solicitação (mapa id→arvore) — alimenta os prazos da tabela.
export const operacaoAawzArvores = (state) => {
  return state.operacaoAawzArvores || {}
}

// Tarefas de solicitação da aba TAREFAS (recorte do board da pasta "Solicitações AAWZ", só as
// raízes de solicitação, enriquecidas com meta de filtro). Alimenta a task-list-view REAL.
export const operacaoAawzBoardTasks = (state) => {
  return (state.operacaoAawzBoardTasks && state.operacaoAawzBoardTasks.data) || []
}

// Contexto do board (folder/sprint da pasta de solicitações) — a view faz selectSprint p/ o
// task-list-view agrupar nativo por status e carregar o mapa de statuses da pasta.
export const operacaoAawzBoardContext = (state) => {
  const bloco = state.operacaoAawzBoardTasks || {}
  return { folderId: bloco.folderId || null, sprintId: bloco.sprintId || null }
}

export const operacaoAawzBoardTasksLoading = (state) => {
  return (state.operacaoAawzBoardTasks && state.operacaoAawzBoardTasks.loading) || false
}

export const operacaoAawzBoardTasksCarregado = (state) => {
  return !!(state.operacaoAawzBoardTasks && state.operacaoAawzBoardTasks.lastUpdate)
}

export const operacaoAawzDetalheAtual = (state) => {
  return (state.operacaoAawzDetalhe && state.operacaoAawzDetalhe.data && state.operacaoAawzDetalhe.data.solicitacao) || null
}

export const operacaoAawzDetalheArvore = (state) => {
  return (state.operacaoAawzDetalhe && state.operacaoAawzDetalhe.data && state.operacaoAawzDetalhe.data.arvore) || []
}

export const operacaoAawzDetalheArquivos = (state) => {
  return (state.operacaoAawzDetalhe && state.operacaoAawzDetalhe.data && state.operacaoAawzDetalhe.data.arquivos) || []
}

export const operacaoAawzDetalheLoading = (state) => {
  return (state.operacaoAawzDetalhe && state.operacaoAawzDetalhe.loading) || false
}

export const operacaoAawzDetalheCarregado = (state) => {
  return !!(state.operacaoAawzDetalhe && state.operacaoAawzDetalhe.lastUpdate)
}

export const operacaoAawzDetalheErro = (state) => {
  return (state.operacaoAawzDetalhe && state.operacaoAawzDetalhe.erro) || false
}

export const operacaoAawzDetalheArvoreCarregando = (state) => {
  return (state.operacaoAawzDetalhe && state.operacaoAawzDetalhe.arvoreCarregando) || false
}
